import { useTranslation } from 'react-i18next';

import { DocsToc } from '../components/docs-shell-toc';
import { mdxComponents } from '../components/mdx/mdx-components';
import type { Guide } from '../content';

/** One MDX guide at reading width, with its headings in the right rail. */
export function GuidePage({ guide }: { guide: Guide }) {
  const { t } = useTranslation('docs');
  const { Component } = guide;
  return (
    <>
      <article className="mx-auto max-w-[72ch]">
        <header className="mb-10 flex flex-col gap-2">
          <p className="text-primary text-sm font-medium">{t('guide.eyebrow')}</p>
          <h1 className="text-3xl font-semibold tracking-tight">{guide.title}</h1>
          <p className="text-muted-foreground text-lg">{guide.description}</p>
        </header>
        <Component components={mdxComponents} />
      </article>
      <DocsToc headings={guide.headings} />
    </>
  );
}
